import api from "../services/api";

export async function getTransportBoxCar(id) {
  return await api.get("/TransportBoxCar/GetEditModel", {
    params: {
      id: id,
    },
  });
}
